import { useMutation } from "react-query"
import { fetchLoadHistory } from "./api"

// eslint-disable-next-line import/prefer-default-export
export const useLoadHistory = () => {
  return useMutation(fetchLoadHistory)
}
